/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_Label_JobInputs */

const en_cover_letters_label_job = /** @type {(inputs: Cover_Letters_Label_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job`)
};

const de_cover_letters_label_job = /** @type {(inputs: Cover_Letters_Label_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stelle`)
};

const fr_cover_letters_label_job = /** @type {(inputs: Cover_Letters_Label_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emploi`)
};

const es_cover_letters_label_job = /** @type {(inputs: Cover_Letters_Label_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empleo`)
};

const it_cover_letters_label_job = /** @type {(inputs: Cover_Letters_Label_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lavoro`)
};

const nl_cover_letters_label_job = /** @type {(inputs: Cover_Letters_Label_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baan`)
};

const pl_cover_letters_label_job = /** @type {(inputs: Cover_Letters_Label_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Praca`)
};

const fi_cover_letters_label_job = /** @type {(inputs: Cover_Letters_Label_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Työpaikka`)
};

const da_cover_letters_label_job = /** @type {(inputs: Cover_Letters_Label_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job`)
};

const sv_cover_letters_label_job = /** @type {(inputs: Cover_Letters_Label_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobb`)
};

/**
* | output |
* | --- |
* | "Job" |
*
* @param {Cover_Letters_Label_JobInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_label_job = /** @type {((inputs?: Cover_Letters_Label_JobInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_Label_JobInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_label_job(inputs)
	if (locale === "fr") return fr_cover_letters_label_job(inputs)
	if (locale === "es") return es_cover_letters_label_job(inputs)
	if (locale === "it") return it_cover_letters_label_job(inputs)
	if (locale === "nl") return nl_cover_letters_label_job(inputs)
	if (locale === "pl") return pl_cover_letters_label_job(inputs)
	if (locale === "fi") return fi_cover_letters_label_job(inputs)
	if (locale === "da") return da_cover_letters_label_job(inputs)
	if (locale === "sv") return sv_cover_letters_label_job(inputs)
	return en_cover_letters_label_job(inputs)
});